import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '../Icons/Close';
import { InstructionsVillageInfoProps } from '../interfaces/components';

const InstructionsVillageInfo = ({ active, setActive, villageName }: InstructionsVillageInfoProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        zIndex={10}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top="auto"
        left="auto"
        bottom={['120px', '120px', '90px']}
        right={['10px', '15px', '25px']}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding={['25px', '25px', '30px 30px', '35px 30px']}
        width={['95vw', '385px', '450px', '615px', '615px']}
        // height={['200px', '200px', '230px', '240px', '240px']}
        height="max-content"
        border="1px solid lightgrey"
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['20px', '20px', '25px']}
          right={['20px', '20px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box>
          <Text
            fontWeight="400"
            fontFamily="SangBleuBPLight"
            fontSize={['16px', '16px', '18px', '20px', '20px']}
            width="100%"
            color="#455255"
          >
            {t(`${villageName}_village_title`)}
          </Text>
          <Text
            fontWeight="500"
            fontSize={['12px', '12px', '14px', '16px', '16px']}
            width="100%"
            color="#455255"
            fontFamily="JosefinSans"
            mt="5"
          >
            {t(`${villageName}_village_body`)}
          </Text>
        </Box>
      </Box>
    </>
  );
};
export default InstructionsVillageInfo;
